export const parseCountriesAllowedFromStorage = (): string[] => {
  try {
    const raw = globalThis.localStorage.getItem('_CAO')

    if (!raw) {
      return []
    }

    const parsed = JSON.parse(raw)

    return Array.isArray(parsed) ? parsed.filter((country): country is string => typeof country === 'string' && country.length > 0) : []
  } catch {
    return []
  }
}
